import { useState, useEffect } from 'react';
import { useLandbotContext } from 'context/landbot.context';
import LANDBOT_DEFAULTS from 'constants/LANDBOT_DEFAULTS';
import _merge from 'lodash.merge';
import Core from '@landbot/core';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

export default function useLandbot(config = {}) {
  const [isFetching, setIsFetching] = useState(true);
  const { landbot, setLandbot } = useLandbotContext();
  
  useEffect(() => {
    const __landbot = new Core(_merge({ firebase }, LANDBOT_DEFAULTS, config));
    window.__landbot = __landbot;
    window.myLandbot = __landbot;
    setLandbot(__landbot);

    Core.utils.asyncUtils
      .fetch({ url: config.configUrl })
      .then((_config) => {
        __landbot.setConfig(_config);
        return __landbot.init();
      })
      .then(() => setIsFetching(false));

    return () => {
      __landbot.destroy();
      setLandbot(null);
    };
  }, []);

  return { isFetching };
}
